import { z } from "zod"

const currentDate = new Date(Date.now());
let startDate: any

const DateSchema = z.object({
  start_time: z.string().refine((val) => {
    startDate = new Date(val)
    return currentDate < startDate
  }, 'Некорректная дата или время'),
  end_time: z.string().refine((val) => {
    const endDate = new Date(val)
    if (startDate) {
      return currentDate < endDate && startDate < endDate
    } else {
      return startDate < endDate
    }
  }, 'Некорректная дата или время'),
})

export default DateSchema
